import { Component, Input, OnInit, ViewChildren, QueryList, EventEmitter, Output, ViewChild, TemplateRef } from '@angular/core';
import { Order, OrderStatus } from '../../resources/order';
import { OrderService } from '../../services/order.service';
import { QuantityTableComponent } from '../quantity-table/quantity-table.component';
import { UserService } from '@cots/common/services/user.service';
import { User } from '@cots/common/resources/user';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';

@Component({
  selector: 'quote-info',
  templateUrl: './quote-info.component.html',
  styleUrls: ['./quote-info.component.less']
})
export class QuoteInfoComponent implements OnInit {
  @Input() record: Order;
  @Input() editing: boolean = false;
  public loading = false;
  public relatedEstimate: Order = null;
  @ViewChildren('quantityTable') components: QueryList<QuantityTableComponent>;
  @ViewChild('vendorTemplateExport') vendorTemplateExport: TemplateRef<any>;
  public vendorTemplateLoading = new BehaviorSubject(false);
  @Output() acceptance = new EventEmitter<void>();

  constructor(private orderService: OrderService, private userSvc: UserService, private dialog: MatDialog) { }
  
  public get userCanAccept(): boolean {
    return this.userSvc.canAccess('CustomerPOAccept', this.userSvc.userData);
  }

  public beginAcceptance() {
    this.acceptance.emit();
  }

  public save(): void {
    if (this.components) {
      this.components.toArray().forEach(p => p.savePricing());
    }
  }

  public updateProducts() {
    if (this.components) {
      this.components.toArray().forEach(p => p.doUpdate());
    }
  }

  private getEstimateDetail(estimateNumber: string): void {
    if (estimateNumber != null)
      this.orderService.getByOrderNumber(estimateNumber).subscribe(result => this.relatedEstimate = result);
  }

  public isEstimateReady(status: number): boolean {
    return status != OrderStatus.IN_PROCESS || status == OrderStatus.AWAITING_REVIEW;
  }

  public getStatusColorClass(status: number): string {
    return OrderStatus.getStatusColorClass(status);
  }

  public getStatusText(status: number): string {
    return OrderStatus.getStatusText(status);
  }

  public getDownloadableQuote() {
    this.loading = true;
    this.orderService.getQuoteFromLineItems(this.record).subscribe(doc => {
      this.loading = false;
      window.open(`/document/${doc.documentId}?inline=true`, "_blank")
    })
  }
  public getDownloadableQuoteOld() {
    this.loading = true;
    this.orderService.getQuote(this.record).subscribe(doc => {
      this.loading = false;
      window.open(`/document/${doc.documentId}?inline=true`, "_blank")
    })
  }

  public promptForVendorTemplate() {
    this.vendorTemplateLoading.next(false);
    this.dialog.open(this.vendorTemplateExport, {
      width: '800px',
      data: {
        documents: this.record.documents
          .map(od => od.document)
          .filter(d => d.mimeType.includes('excel') || d.mimeType.includes('spreadsheet')),
        retrieveVendorExport: this.retrieveVendorExport.bind(this),
      }
    });
  }

  public async retrieveVendorExport(documentId: string, upload: File = null) {
    let request = null;
    if (documentId !== null)
      request = this.orderService.getSikorskySheet(null, documentId, this.record.orderSegmentId);
    else if (upload !== null)
      request = this.orderService.getSikorskySheet(upload, null, this.record.orderSegmentId);

    if (request) {
      this.vendorTemplateLoading.next(true);
      request.subscribe(resp => {
        const headers = resp.headers.get('Content-Disposition').split('; ');
        const filename = headers[1].substring(headers[1].indexOf('=') + 1);
        const url = URL.createObjectURL(resp.body);

        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = filename;

        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(url);

        this.vendorTemplateLoading.next(false);
      });
    }
  }


  public get allQuantitiesSelected(): boolean {
    return this.components && this.components.toArray().every(c => c.allQuantitiesSelected)
  }

  ngOnInit(): void {
    this.getEstimateDetail(this.record.estimateNumber);
  }
}
